mail-dialog-new-title = Neues Beratungsanliegen
mail-dialog-new-breadcrumb = Neues Beratungsanliegen

help-seeker-mail-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [skill] Thema des Beratungsanliegens
    [subject] Betreff
    [content] Ihre Nachricht
    [attachments] Anhänge
  }

help-seeker-mail-fields-placeholders =
  { $field ->
    *[x_unknown] [{$field}]
    [subject] Geben Sie Ihrem Anliegen eine Überschrift
    [content] Beschreiben Sie Ihr Anliegen bitte mit den erforderlichen Details
  }

mail-category-choose = Bitte wählen Sie eines der folgenden Themen aus:
mail-category-group =
  { $group ->
    *[x_unknown] [{$group}]
    [rights] Geht es um Ihre Krankenkasse oder Ihre Rechte als Patientin oder Patient?
    [health] Geht es um ihre Gesundheit?
    [mental_health] Geht es um den Umgang mit einer schwierigen Lebenssituation oder haben Sie fragen rund um psychische Erkrankungen?
    [others] Sie haben andere Themen, zu denen Sie Beratung wünschen oder finden sich in den Fragen nicht wieder?
  }
mail-category-select =
  { $option ->
    *[x_unknown] [{$option}]
    [social_security] Ich habe Probleme mit meiner Kranken- oder Pflegekasse
    [medical_error] Es geht um einen Behandlungsfehler
    [care_planning] Es geht um Vorsorgedokumente oder Betreuung
    [legal] Ich habe andere rechtliche Fragen
    [dental] Es geht um meine Zähne
    [medication] Es geht um Medikamente und deren Nebenwirkungen
    [health_issues] Es geht um andere gesundheitliche Fragen
    [psychological] Es geht um eine schwierige Lebenssituation oder um das Thema psychische Erkrankungen
    [others] Ich habe andere Themen oder finde mich in den Fragen nicht wieder
  }

help-seeker-mail-attachment-size-exceeded = Die maximale Dateigröße von {$maxSize} MB wurde überschritten.
help-seeker-mail-remove-attachment = „{$name}“ entfernen
help-seeker-mail-send = Nachricht senden
help-seeker-mail-send-success = Ihre Nachricht wurde erfolgreich gesendet. Antwort der Stiftung ausstehend.

help-seeker-mail-response-pending-info =
  <strong>Aktueller Schritt:</strong> Antwort der Stiftung ausstehend. Sobald die Stiftung zu Ihrem Anliegen Stellung genommen hat, können Sie hier Maßnahmen planen und weitere Fragen stellen.
help-seeker-mail-back-to-dashboard = Zurück zum Dashboard

## Dialog

dialog-mail-message-generic-author = {-company-short-name}

dialog-mail-reply-show-form = Antworten
dialog-mail-reply-heading = Antwort
dialog-mail-reply-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [message] Antwort
    [attachments] Anhänge
  }

dialog-mail-reply-save-draft = Entwurf speichern

dialog-mail-reply-send = Antwort senden
dialog-mail-reply-send-dialog-title =
  { $type ->
    *[counselor] Antwort an Ratsuchende:n senden
    [help_seeker] Antwort senden
  }
dialog-mail-reply-send-dialog-message =
  { $type ->
    *[counselor] <p>Bitte bestätige den Versand der Antwort an die:den Ratsuchende:n.</p>
    [help_seeker] <p>Bitte bestätigen Sie Ihre Antwort.</p>
  }
  <p>Das Senden kann <strong>nicht rückgängig</strong> gemacht werden.</p>
dialog-mail-reply-send-dialog-confirm = Ja, Antwort senden
dialog-mail-reply-send-success =
  { $type ->
    *[x_unknown] [{$type}]
    [draft_reply] Entwurf gespeichert
    [assigned] Antwort an Ratsuchende:n gesendet
    [new] Ihre Antwort wurde übermittelt
  }
dialog-mail-reply-send-error = Entschuldigung, ich konnte die Antwort nicht senden.

dialog-mail-reply-reset = Verwerfen
dialog-mail-reply-reset-dialog-title = Antwort verwerfen
dialog-mail-reply-reset-dialog-message = Deine nicht gesendete Antwort wird verworfen und das Antwort-Formular geleert.
dialog-mail-reply-reset-dialog-confirm = Ja, Antwort verwerfen

dialog-mail-close = Kontakt beenden
dialog-mail-close-dialog-title = Kontakt beenden
dialog-mail-close-dialog-message =
  <p>Nach Beendigung können Ratsuchende nur mit einer neuen Erstmail erneut Kontakt zur Mail-Beratung aufnehmen.</p>
  <p>Der Mail-Dialog bleibt als beendeter Dialog für weitere 6 Monate in dieser Liste verfügbar.</p>
  <p>Selle sicher, dass du die letzte Dokumentation bereits angepasst hast oder erstelle eine neue Dokumentation, die das <em>Ende der Beendigung des Kontakts</em> erfasst.</p>
dialog-mail-close-dialog-confirm = Ja, Kontakt beenden
dialog-mail-close-success = Kontakt wurde beendet und der Mail-Dialog ist für weitere 6 Monate einsehbar
dialog-mail-download-attachment-label = „{$name}“ herunterladen
dialog-mail-view-attachment-label = „{$name}“ öffnen ({global-link-opens-in-new-tab})
dialog-mail-reply-draft-attachment = Entwurf-Anhang
dialog-mail-remove-attachment = „{$name}“ entfernen
